import React from 'react';
import './Header.css';

import HeaderAbout from '../HeaderAbout/HeaderAbout';
import HeaderStuffButton from '../HeaderStuffButton/HeaderStuffButton';

function Header(props) {
  return (
    <div className="Header">
      <HeaderAbout/>
      <HeaderStuffButton onClick={props.onClick}/>
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js